export enum BillPaymentType {
  CASH = "CASH",
  CHEQUE = "CHEQUE",
  TRANSFER = "TRANSFER",
  CREDIT_CARD = "CREDIT_CARD",
  MOBILE_MONEY = "MOBILE_MONEY",
}
